import { SpaceProps } from '@wrisk/styled-system'
import React, { FunctionComponent } from 'react'

import { getCurrentQuote, isCoverActive } from '../../../domain'
import { useDiscountCovers } from '../../../hooks/covers'
import { TKey } from '../../../infrastructure/internationalisation'
import { useProposal } from '../../product/proposal/ProposalProvider'
import { PromotionBanner } from './PromotionBanner'

const tKey = TKey('components.promotion-banner')

export const RenewalPromotionBanner: FunctionComponent<SpaceProps> = (props) => {
  const { proposal } = useProposal()
  const quote = getCurrentQuote(proposal)
  const [discount] = useDiscountCovers(quote)

  return quote.promoCode && isCoverActive(discount) ? (
    <PromotionBanner
      tKey={tKey}
      promoCode={quote.promoCode}
      variant='narrow'
      {...props}
    />
  ) : null
}
